module.exports = __webpack_public_path__ + "img/circle-border-lg.6117ee05.svg";